import { useEffect, useState } from "react";
import { PageHeader, Panel } from "@/components/app/ui";
import { SectionHelp } from "@/components/app/Help";
import { JourneyBar } from "@/components/app/JourneyBar";
import { GovControl } from "@/components/governance/GovControl";
import { api, can } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Governance() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [ev, setEv] = useState([]);
  const load = () => api.get("/governance").then((r) => setD(r.data));
  useEffect(() => { load(); api.get("/evidence").then((r) => setEv(r.data)); }, []);
  if (!d) return null;
  const sm = d.summary;
  return (
    <div>
      <PageHeader title="Security & Governance Measures" testId="page-title" subtitle="One place for your governance, security, lifecycle, vendor and incident controls — replaces the earlier governance baseline." />
      <JourneyBar compact />
      <SectionHelp id="governance" />
      <div className="mb-5 flex flex-wrap gap-2 text-xs" data-testid="gov-summary">
        {d.states.map((s) => <span key={s} className="rounded-full border border-slate-200 bg-white px-3 py-1">{s}: <b>{sm[s]}</b></span>)}
        <span className="rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-amber-800">Unverified: <b>{sm.unverified}</b></span>
      </div>
      <div className="space-y-5">
        {d.categories.map((cat) => (
          <Panel key={cat.key} title={`${cat.key}. ${cat.name}`} testId={`gov-category-${cat.key}`}>
            <p className="-mt-1 mb-2 text-xs text-slate-500">{cat.help}</p>
            <div className="-mx-4 border-t">{d.controls.filter((c) => c.category === cat.key).map((c) => <GovControl key={c.key} c={c} states={d.states} evidence={ev} editable={can(user, "assess")} onSaved={load} />)}</div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
